import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import PublicShell from "@/components/PublicShell";
import AdminCalendar from "@/pages/AdminCalendar";
import EventCalendarPage from "@/pages/EventCalendarPage";
import EventDetailPage from "@/pages/EventDetailPageV2";
import EventsPage from "@/pages/EventsPage";
import FighterPage from "@/pages/FighterPageV2";
import GymsPage, { GymDetailPage } from "@/pages/GymsPage";
import GymsAdminPage from "@/pages/GymsAdminPage";
import ImportPage from "@/pages/ImportPage";
import LoginPage from "@/pages/LoginPage";
import ManagementPage from "@/pages/ManagementPage";
import MatchPage from "@/pages/MatchPageV2";
import MyFightsPage from "@/pages/MyFightsPage";
import RankingsPage from "@/pages/RankingsPage";
import RingSchedulePage from "@/pages/RingSchedulePage";
import RegisterPage from "@/pages/RegisterPage";
import SettingsPage from "@/pages/SettingsPage";
import {
  SponsorsPage, SponsorDetailPage, SponsorsAdminPage,
  ProjectsPage, ProjectDetailPage, ProjectsAdminPage,
  NewsPage, NewsDetailPage, NewsAdminPage,
  HomeNewsPage,
} from "@/pages/CmsPages";

function ProtectedLayout() {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading" data-testid="auth-loading">WBC MUAY THAI WIRD GELADEN …</div>;
  return user ? <AppShell /> : <Navigate to="/login" replace />;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="app-loading" data-testid="auth-loading">WBC MUAY THAI WIRD GELADEN …</div>;
  return user ? <Navigate to="/events" replace /> : children;
}

export default function App() {
  return <AuthProvider><BrowserRouter><Routes>
    {/* Öffentlicher Bereich */}
    <Route element={<PublicShell />}>
      <Route path="/" element={<HomeNewsPage />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/news/:id" element={<NewsDetailPage />} />
      <Route path="/projekte" element={<ProjectsPage />} />
      <Route path="/projekte/:id" element={<ProjectDetailPage />} />
      <Route path="/sponsoren" element={<SponsorsPage />} />
      <Route path="/sponsoren/:id" element={<SponsorDetailPage />} />
      <Route path="/gyms" element={<GymsPage />} />
      <Route path="/gyms/:id" element={<GymDetailPage />} />
      <Route path="/kalender" element={<EventCalendarPage />} />
      <Route path="/rangliste" element={<RankingsPage />} />
    </Route>
    <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
    <Route path="/register" element={<PublicOnly><RegisterPage /></PublicOnly>} />
    {/* Portal (nach Login) */}
    <Route element={<ProtectedLayout />}>
      <Route path="/events" element={<EventsPage />} />
      <Route path="/calendar" element={<EventCalendarPage />} />
      <Route path="/calendar/admin" element={<AdminCalendar />} />
      <Route path="/events/:id" element={<EventDetailPage />} />
      <Route path="/events/:id/import" element={<ImportPage />} />
      <Route path="/events/:id/rings" element={<RingSchedulePage />} />
      <Route path="/fighters/:id" element={<FighterPage />} />
      <Route path="/match/:id" element={<MatchPage />} />
      <Route path="/my-fights" element={<MyFightsPage />} />
      <Route path="/rankings" element={<RankingsPage />} />
      <Route path="/gyms-admin" element={<GymsAdminPage />} />
      <Route path="/sponsoren-admin" element={<SponsorsAdminPage />} />
      <Route path="/projekte-admin" element={<ProjectsAdminPage />} />
      <Route path="/news-admin" element={<NewsAdminPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="/settings/:section" element={<ManagementPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></BrowserRouter><Toaster theme="dark" position="top-center" /></AuthProvider>;
}
